import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setCheckOutConfirmIsOpen } from 'redux/checkOutConfirmInfoSlice'
import Spinner from 'components/Spinner';
import EighthFloor from '../FloorPlan/EighthFloor'
import NinthFloor from '../FloorPlan/NinthFloor'
import TenthFloor from '../FloorPlan/TenthFloor'
import Legend from '../Legend'
import ModalRoomChange from "screens/ModalRoomChange";
import { useQuery } from '@apollo/client';
import { GET_AVAILABLE_ROOMS_FOR_ROOM_CHANGE, SUBSCRIBE_TO_ROOMS_UPDATED } from 'graphql/service';
import ActiveMapLegend from 'assets/icons/activeMapLegend.svg'
import MapLegend from 'assets/icons/mapLegend.svg'
import { Container, Header, ViewLegend, MapRow } from './style';
import colors from 'constants/colors'
import { debouncedErrorMessage } from 'utils/messageUtil'

const ManageRooms = () => {

  const bookingId = useParams().bookingId;
  const dispatch = useDispatch()
  const [isLegendVisible, setIsLegendVisible] = useState(false)
  const [eighthFloorRooms, setEighthFloorRooms] = useState({})
  const [ninthFloorRooms, setNinthFloorRooms] = useState({})
  const [tenthFloorRooms, setTenthFloorRooms] = useState({})
  const checkOutConfirmInfo = useSelector(
    (state) => state.checkOutConfirmInfoReducer
  );

  const {
    loading,
    data: availableRoomsData,
    error,
    subscribeToMore,
  } = useQuery(GET_AVAILABLE_ROOMS_FOR_ROOM_CHANGE, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    variables: { 
      input: {
        bookingId: bookingId
      }
    },
    onCompleted: (roomsData) => {
      let newEighthFloorRooms = {};
      let newNinthFloorRooms = {};
      let newTenthFloorRooms = {};
      roomsData.availableRoomsForRoomChange.forEach((room) => {
        switch (room.floor) {
          case "8":
            newEighthFloorRooms[room.roomNumber] = room;
            break;
          case "9":
            newNinthFloorRooms[room.roomNumber] = room;
            break;
          case "10":
            newTenthFloorRooms[room.roomNumber] = room;
            break;
          default:
            break;
        }
      });
      setEighthFloorRooms(newEighthFloorRooms);
      setNinthFloorRooms(newNinthFloorRooms);
      setTenthFloorRooms(newTenthFloorRooms);
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(
            error.graphQLErrors[0]?.extensions?.exception
          );
        }
        debouncedErrorMessage(content);
      }
    },
  });

  // useEffect(() => {
  //   if (availableRoomsData) {
  //     const unsubscribe = subscribeToMore({
  //       document: SUBSCRIBE_TO_ROOMS_UPDATED,
  //       updateQuery: (prev, { subscriptionData }) => {
  //         if (!subscriptionData.data?.roomMapUpdated) return;
  //         const updatedRooms = subscriptionData.data?.roomMapUpdated;

  //         const mergedRooms = prev.validRooms.map((room) => {
  //           const updated = updatedRooms.find(
  //             (element) => element.roomId === room.roomId
  //           );
  //           return updated ? updated : room;
  //         });
  //         if (
  //           prev.validRooms?.some(
  //             (room) => room.roomId === updatedRooms.alertId
  //           )
  //         ) {
  //           return prev;
  //         }
  //         return {
  //           ...prev,
  //           validRooms: [...mergedRooms],
  //         };
  //       },
  //     });

  //     return () => {
  //       unsubscribe();
  //     };
  //   }
  // }, [availableRoomsData, subscribeToMore]);
    
  if (loading) return <Spinner />;
  if (error) return <p>Error! {error.message}</p>;

  return (
    <Container>
      <Header>
        <ViewLegend
          onClick={() => setIsLegendVisible(!isLegendVisible)}
          active={isLegendVisible}
        >
          {isLegendVisible ?
            <img src={ActiveMapLegend} alt={'activeMapLegend'} /> :
            <img src={MapLegend} alt={'mapLegend'} />}
          <div>{isLegendVisible ? 'HIDE LEGEND' : 'VIEW LEGEND'}</div>
        </ViewLegend>
      </Header>
      <MapRow>
        <EighthFloor scale={1.25} backgroundColor={colors.black1} rooms={eighthFloorRooms} />
        <NinthFloor scale={1.25} backgroundColor={colors.black1} rooms={ninthFloorRooms} />
        <TenthFloor scale={1.25} backgroundColor={colors.black1} rooms={tenthFloorRooms} />
      </MapRow>
      { isLegendVisible? <Legend desktop/> : null}
      <ModalRoomChange />
    </Container>
  );
};

export default ManageRooms;
